import React, { Component } from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { StatusBar } from 'react-native';
import { serverURL, feUrl } from '../constants/serverURL'
var pako = require('../utils/pako.min.js');
var wasm_exec = require('../utils/wasm_exec.js');
import { Preferences } from '@capacitor/preferences';
import { initializeAdmob, showBanner, showInterstitial, showRewardedVideo, closeBanner } from '../utils/admob';

// ...

function getHeight() {
    if (Platform.OS === "android") {
        return StatusBar.currentHeight
    }
    return 30
}
export default class GameIframe extends Component {

    constructor(props) {
        super(props);
        this.state = {
            boardUrl: "/loading",
        }
    }

    componentDidMount(): void {
        Preferences.get({ key: 'gameMeta' }).then((result) => {
            const gameMeta = JSON.parse(result.value);
            var meta = btoa(JSON.stringify(gameMeta));
            this.setState({
                boardUrl: "/board?gm=" + meta
            })
        });

        initializeAdmob().then(() => {
            console.log("Admob initialized")
        })
        

        window.addEventListener('message', (event) => {
            console.log("Received message event: " + event.data);
            if (event.data == "showBanner") {
                showBanner().then(() => {
                    console.log("Banner Ad loaded")
                }).catch((error) => {
                    console.log("Banner Ad failed to load with error: " + error);
                });
            } else if (event.data == "showInterstitial") {
                showInterstitial().then(() => {
                    console.log("Show Interstitial loaded")
                }).catch((error) => {
                    console.log("Show Interstitial failed to load with error: " + error);
                });
            } else if (event.data == "showRewardedVideo") {
                showRewardedVideo().then(() => {
                    console.log("Rewarded Video Ad loaded")
                }).catch((error) => {
                    console.log("Rewarded Video Ad failed to load with error: " + error);
                });
            } else if (event.data == "closeBanner") {
                closeBanner();
            }
          
        });

        this.props.navigation.addListener("tabPress", async (e) => {
            // add your business logic here
            console.log("Game tab pressed")
            showBanner().then(() => {
                console.log("Banner Ad loaded")
            }).catch((error) => {
                console.log("Banner Ad failed to load with error: " + error);
            });
        })


    }

    componentWillUnmount(): void {
        closeBanner();
        window.removeEventListener('message', (event) => {
            console.log("Removing event listener");
        });
    }

    onNavigationStateChange(navState) {
        this.setState({
            canGoBack: navState.canGoBack
        });
    }

    render() {




        return (

            <iframe width="100%"
                height="100%" src={this.state.boardUrl}></iframe>
        )

    }
}
